import React, { useState } from 'react';
import { useAuth } from '../../../hooks/useAuth';
import { MapPin, Plus, Building2, Zap, Shield, DollarSign, Wind, Server } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { AddLocationModal } from '../modals/AddLocationModal';
import { EmptyLocations } from '../EmptyLocations';
import { LocationList } from '../LocationList';

export function LocationsTab() {
  const { user } = useAuth();
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [selectedLocations, setSelectedLocations] = useState<string[]>(user?.locationIds || []);

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex items-center justify-between">
        <div>
          <h2 className="text-lg font-semibold text-gray-900 flex items-center gap-2">
            <MapPin className="w-5 h-5 text-gray-500" />
            Managed Locations
          </h2>
          <p className="mt-1 text-sm text-gray-500">
            Manage your mining facility locations
          </p>
        </div>
        {selectedLocations.length > 0 && (
          <button
            onClick={() => setIsAddModalOpen(true)}
            className="flex items-center gap-2 px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-lg hover:bg-blue-700 transition-colors"
          >
            <Plus className="w-4 h-4" />
            Add Location
          </button>
        )}
      </div>

      {/* Content */}
      <AnimatePresence mode="wait">
        {selectedLocations.length === 0 ? (
          <EmptyLocations onAddLocation={() => setIsAddModalOpen(true)} />
        ) : (
          <LocationList 
            locations={selectedLocations}
            onAddLocation={() => setIsAddModalOpen(true)}
          />
        )}
      </AnimatePresence>

      {/* Add Location Modal */}
      <AnimatePresence>
        {isAddModalOpen && (
          <AddLocationModal
            isOpen={isAddModalOpen}
            onClose={() => setIsAddModalOpen(false)}
          />
        )}
      </AnimatePresence>
    </div>
  );
}